
import React, { useEffect, useState } from "react";
import { useAuth } from "../hooks/useAuth";
import { Box, Heading, Flex, Spinner, Table, Thead, Tbody, Tr, Th, Td, Badge, useColorModeValue, Text, Divider } from "@chakra-ui/react";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
function AdminDashboard() {
  const { user } = useAuth();
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const boxBg = useColorModeValue("white", "gray.800");

  useEffect(() => {
    const fetchRequests = async () => {
      try {
        const token = await user.getIdToken();
        const res = await fetch(`${API_BASE_URL}/api/admin/genome-requests`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) throw new Error("Failed to fetch requests");
        const data = await res.json();
        setRequests(data);
      } catch (err) {
        setError("Could not load genome requests");
      } finally {
        setLoading(false);
      }
    };
    if (user) fetchRequests();
  }, [user]);

  return (
    <Box maxW="7xl" mx="auto" p={6}>
      <Heading mb={6} textAlign="center" color="teal.600">Admin Dashboard</Heading>
      <Divider mb={6} />
      {loading ? (
        <Flex justify="center" align="center" minH="200px"><Spinner size="xl" /></Flex>
      ) : error ? (
        <Text color="red.500" textAlign="center">{error}</Text>
      ) : (
        <Box bg={boxBg} p={6} borderRadius="lg" boxShadow="md">
          <Heading size="md" mb={4}>Genome Test Requests</Heading>
          <Table variant="striped" colorScheme="teal" size="sm">
            <Thead>
              <Tr>
                <Th>User</Th>
                <Th>Email</Th>
                <Th>Status</Th>
                <Th>Date</Th>
              </Tr>
            </Thead>
            <Tbody>
              {requests.length === 0 ? (
                <Tr><Td colSpan={4}><Text>No requests found.</Text></Td></Tr>
              ) : (
                requests.map((req) => (
                  <Tr key={req._id}>
                    <Td>{req.userName || "-"}</Td>
                    <Td>{req.userEmail || "-"}</Td>
                    <Td><Badge colorScheme={req.status === "completed" ? "green" : req.status === "pending" ? "yellow" : "gray"}>{req.status}</Badge></Td>
                    <Td>{new Date(req.createdAt).toLocaleString()}</Td>
                  </Tr>
                ))
              )}
            </Tbody>
          </Table>
        </Box>
      )}
    </Box>
  );
}

export default AdminDashboard;
